import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Grid, Paper, Typography } from "@material-ui/core";
import PropTypes from "prop-types";

// API
import { getUserPointsLog } from "../../api/Points";
import { Skeleton } from "@material-ui/lab";

/**
 * Styles
 */
const useStyles = makeStyles(() => ({
  paper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "20px",
    height: "330px",
    whiteSpace: "nowrap",
    marginTop: "20px",
  },
}));

function UserPointsLog(propts) {
  const classes = useStyles();
  const [points_log, setPoints_log] = useState([]);
  const { user_id } = propts;
  const [loading, setLoading] = useState(false);

  const getSchedulePoints = () => {
    setLoading(true);
    getUserPointsLog(user_id).then((result) => {
      if (result.error) {
        console.error("Error fetching points log:", result.error);
        return;
      }
      setPoints_log(result.data.points || []);
      setLoading(false);
    });
  };

  // Get points_log when client_id changes
  useEffect(() => {
    getSchedulePoints();
  }, [propts.user_id]);

  // Get points_log when client_id changes
  useEffect(() => {
    if (propts.reloadClientPointsLog) getSchedulePoints();
    propts.setReloadClientPointsLog(false);
  }, [propts.reloadClientPointsLog]);

  return (
    <div>
      <Paper variant="outlined" className={classes.paper}>
        {loading ? (
          // Skeleton
          <>
            <Grid container spacing={2}>
              {/* Title */}
              <Grid id="grid_title" xs={4} item sm={4} md={4}>
                <Skeleton height={41.6} />
              </Grid>
            </Grid>
            {new Array(4).fill(0).map((_, index) => (
              <Grid container spacing={2} key={index}>
                <Grid item xs={3} md={3} lg={3}>
                  <Skeleton height={41.6} />
                </Grid>
                <Grid item xs={3} md={3} lg={3}>
                  <Skeleton height={41.6} />
                </Grid>
                <Grid item xs={3} md={3} lg={3}>
                  <Skeleton height={41.6} />
                </Grid>
                <Grid item xs={3} md={3} lg={3}>
                  <Skeleton height={41.6} />
                </Grid>
              </Grid>
            ))}
          </>
        ) : (
          // Container
          <Grid container spacing={2}>
            {/* Title */}
            <Grid id="grid_title" xs={12} item sm={6} md={6}>
              <Typography variant="h6" gutterBottom>
                Points Log
              </Typography>
            </Grid>

            {/* Schedule points headers*/}
            <Grid container spacing={1}>
              <Grid item xs={3} md={3} lg={3}>
                <Typography
                  variant="subtitle1"
                  gutterBottom
                  style={{ paddingLeft: "10px" }}
                >
                  <b> ASSIGNED BY</b>
                </Typography>
              </Grid>
              <Grid item xs={3} md={3} lg={3}>
                <Typography
                  variant="subtitle1"
                  gutterBottom
                  style={{ paddingLeft: "10px" }}
                >
                  <b> POINTS</b>
                </Typography>
              </Grid>
              <Grid item xs={3} md={3} lg={3}>
                <Typography
                  variant="subtitle1"
                  gutterBottom
                  style={{ paddingLeft: "10px" }}
                >
                  <b>DIVISION</b>
                </Typography>
              </Grid>
              <Grid item xs={3} md={3} lg={3}>
                <Typography
                  variant="subtitle1"
                  gutterBottom
                  style={{ paddingLeft: "10px" }}
                >
                  <b>DATE</b>
                </Typography>
              </Grid>
            </Grid>

            {/* Schedule points List */}
            <Grid
              xs={12}
              md={12}
              lg={12}
              style={{
                maxHeight: 270,
                overflowY: "auto",
                overflowX: "hidden",
              }}
            >
              {points_log.length > 0 ? (
                points_log.map((points, index) => {
                  return (
                    <Grid key={index} container spacing={2}>
                      <Grid item xs={3} md={3} lg={3}>
                        <Typography
                          variant="subtitle1"
                          gutterBottom
                          style={{ paddingLeft: "10px" }}
                          noWrap
                        >
                          {points.created_by_user?.Details
                            ? `${points.created_by_user.Details.FirstName} ${points.created_by_user.Details.LastName}`
                            : points.created_by_user?.username || "-"}
                        </Typography>
                      </Grid>
                      <Grid item xs={3} md={3} lg={3}>
                        <Typography
                          variant="subtitle1"
                          gutterBottom
                          style={{ paddingLeft: "10px" }}
                        >
                          {points.Balance}
                        </Typography>
                      </Grid>
                      <Grid item xs={3} md={3} lg={3}>
                        <Typography
                          variant="subtitle1"
                          gutterBottom
                          style={{ paddingLeft: "10px" }}
                          noWrap
                        >
                          {points.division_category?.Name || "-"}
                        </Typography>
                      </Grid>
                      <Grid item xs={3} md={3} lg={3}>
                        <Typography
                          variant="subtitle1"
                          gutterBottom
                          style={{ paddingLeft: "10px" }}
                        >
                          {new Date(points.created_at).toLocaleDateString(
                            "en-US",
                            {
                              year: "numeric",
                              month: "2-digit",
                              day: "2-digit",
                            }
                          )}
                        </Typography>
                      </Grid>
                    </Grid>
                  );
                })
              ) : (
                <Grid item xs={12}>
                  <Typography align="center" variant="subtitle1">
                    No points
                  </Typography>
                </Grid>
              )}
            </Grid>
          </Grid>
        )}
      </Paper>
    </div>
  );
}

UserPointsLog.propTypes = {
  contact_user: PropTypes.object,
  loading: PropTypes.bool,
};

export default UserPointsLog;
